import React from 'react'
import Typed from 'react-typed';
import profile from '../images/profile.jpeg';

const Hero = () => {
  return (
    <>
    <div className="bg-[url('https://i.postimg.cc/PqckZnBC/bgjpg.jpg')] bg-no-repeat bg-cover">
    <div className="w-[70%] m-[auto] md:h-[700px]">
   
        <div className='md:flex justify-around'>
          <div className='flex flex-col'>
            <h1 className='text-[white]  text-[50px]'>
            I am a Front-End Developer,<br/>
             <Typed className='text-[#E5038B] text-[60px] font-bold '
                    strings={ [' React Js','UI','Tailwind CSS',"Bootstrap","Python"]}
                    typeSpeed={40}
                    backSpeed={140}
                    loop/>  
                    <p className='text-[14px] text-[white]'>Lorem ipsum dolor sit amet consectetur adipisicing elit.,<br/> Facilis quasplaceat dolores voluptates blanditiis aspernatur ullam hic eaque nulla recusandae!</p>
        </h1>
          </div>
  
       <div className="">
        <img src={profile} className="h-[200px] rounded-[50%]" />
       </div>

    </div>
        
      
    <div className="flex mt-[50px]">
<a href="#Projects"><button className='bg-[white] text-[#E5038B] w-[120px] h-[70px] ml-[50px] rounded-lg shadow-2xl'>Projects</button></a>
    </div> 
     
    </div>
    </div>
 
    </>
  )
}

export default Hero